<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query['storer.id']" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-input v-model="query.no" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table
        :column-config="{resizable:true}"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :row-config="{isCurrent: true, isHover: true}"
        align="center"
        ref="table"
        border
        :data="list"
        :loading="loading"
        round
        :scroll-x="{enabled: true}"
        size="mini"
        show-header-overflow
        show-overflow
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="storers" title="business.label.storer" width="150">
          <span slot-scope="{row}">{{getStrings(row.storers, 'name')}}</span>
        </vxe-column>
        <vxe-column field="no" title="business.label.itemNo" width="100"/>
        <vxe-column field="name" title="business.label.ChineseName" width="300"/>
        <vxe-column field="mnemonicCode" title="business.label.mnemonicCode" width="150"/>
        <vxe-column field="itemType.name" title="business.label.itemType" width="80"/>
        <vxe-column field="itemCategory.name" title="business.label.itemCategory" width="80"/>
        <vxe-column field="legalAttribute.name" title="business.label.legalAttribute" width="80"/>
        <vxe-column field="brand.name" title="business.label.brand" width="80"/>
        <vxe-column field="season.name" title="business.label.season" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:dataSources}" field="dataSource" title="business.label.dataSource" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:saleClassifications}" field="saleClassification" title="business.label.saleClassification" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageClassifications}" field="storageClassification" title="business.label.storageClassification" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageEnvironments}" field="storageEnvironment" title="business.label.storageEnvironment" width="80"/>
        <vxe-column field="daysOfExpirationNearly" title="business.label.daysOfExpirationNearly" width="100"/>
        <vxe-column field="daysOfProductionNearly" title="business.label.daysOfProductionNearly" width="100"/>
        <vxe-column field="daysOfInspectionNearly" title="business.label.daysOfInspectionNearly" width="100"/>
        <vxe-column field="numberOfLot" title="business.label.numberOfLot" width="80"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{readonly:true}}" field="importation" title="business.label.importation" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{readonly:true}}" field="valuable" title="business.label.valuable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{readonly:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{readonly:true}}" field="supervised" title="business.label.supervised" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
            <vxe-button content="business.label.config" icon="vxe-icon-association-form" status="primary" @click.stop="config(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import { getStrings } from '@/utils/util'

export default {
  name: 'ItemTable',
  data() {
    return {
      loading: false,
      query: { no: '', name: '', 'storer.id': undefined },
      list: [],
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  props: {
    storers: {
      type: Array,
      default: []
    },
    dataSources: {
      type: Array,
      default: []
    },
    saleClassifications: {
      type: Array,
      default: []
    },
    storageClassifications: {
      type: Array,
      default: []
    },
    storageEnvironments: {
      type: Array,
      default: []
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    getStrings,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('itemFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.list = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '', 'storer.id': undefined }
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row) {
      this.$emit('edit', row.id, false)
    },
    copy(row) {
      this.$emit('edit', row.id, true)
    },
    config(row) {
      this.$emit('config', new Item(row))
    }
  }
}
</script>